import React from 'react';
import { personalInformationData } from '../../data';
import { CommitsCountCard } from '../styled/Commits.styled';

const CommitsCount = () => {
    return (
        <>
            <CommitsCountCard>
                <h2>{personalInformationData.githubCommits}+</h2>
                <p>Github Commits</p>
            </CommitsCountCard>
        </>
    );
};

export default CommitsCount;